import { Children, Fragment, HTMLAttributes, ReactNode, useMemo } from 'react';
import cn from 'clsx';

import { RowContext, useRowContext, ParentRowContext } from './RowContext';

import styles from './TableRow.module.scss';

interface TableRowProps extends HTMLAttributes<HTMLTableRowElement> {
  children: ReactNode;
  isEven: boolean;
  striped: boolean;
}

export function TableRow({
  children,
  isEven,
  className,
  striped,
  ...props
}: TableRowProps) {
  const rows = useMemo(() => Children.toArray(children), [children]);
  const value = useMemo(
    () => ({
      isEven,
    }),
    [isEven]
  );

  const parent = useRowContext(true);

  return (
    <ParentRowContext.Provider value={parent ?? value}>
      <RowContext.Provider value={value}>
        {rows.map((row, idx) => (
          // TODO тут нужно какой-нибудь key прицепить чтобы не было ошибки в консоли браузера
          // index.js:1 Warning: Each child in a list should have a unique "key" prop.
          // Check the render method of `TableRow`. See https://reactjs.org/link/warning-keys for more information.
          <tr
            className={cn(className, styles.row, {
              [styles.hasNext]: rows[idx + 1],
              first: idx === 0,
              last: !rows[idx + 1],
              [styles.isOdd]: !isEven && striped,
            })}
            // eslint-disable-next-line react/no-array-index-key
            key={idx}
            {...props}
          >
            {row}
          </tr>
        ))}
      </RowContext.Provider>
    </ParentRowContext.Provider>
  );
}

TableRow.Line = Fragment;
TableRow.useRowContext = useRowContext;
